(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("plain-kit", [], factory);
	else if(typeof exports === 'object')
		exports["plain-kit"] = factory();
	else
		root["plain-kit"] = factory();
})(window, function() {
return 